import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './GreetingClient.css';

const GreetingClient = (props, context) => {
  const statuses = {
    CANC: 'CANCELLED',
    REV: 'REVOQUED',
    PEND: 'PENDING',
    CONF: 'CONFIRMED',
  };

  return (
    <div className="greeting-container">
      <h1 className="greeting-title">{context.t('Hi')} <span className='colorBlue'>{props.name}</span>!</h1>
      <h2 className="greeting-subtitle"><span className='colorBlue'>{context.t('YOUR RESERVATION')} {props.bookingStatus === 'PEND' ? context.t('IS') : context.t('HAS BEEN')} {context.t(statuses[props.bookingStatus])}</span></h2>

      <div className="greeting-message">
        <p>
          {props.hotel ? context.t('On behalf of the Sandos family, we would like to warmly welcome you to {hotel_name}.', { hotel_name: props.hotel.name }) : ''}
        </p>
        <p>
          {context.t('We are looking forward to your upcoming visit. Below you will find your reservation details:')}
        </p>
      </div>
    </div>
  );
};

GreetingClient.propTypes = {
  name: PropTypes.string.isRequired,
  bookingStatus: PropTypes.string.isRequired,
};

GreetingClient.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  multipleRoomSelection: state.booking.multipleRoomSelection,
  cart: state.cart,
  lang: state.i18nState.lang,
  hotel: state.booking.hotel,
}))(GreetingClient);
